<template>
<div class="vx-row">
    <div class="vx-col w-full">
        <vx-card fixed-height="true">
            <vs-row>
                <vs-col type="flex" vs-justify="flex-start" vs-align="flex-start" class="m-2" vs-w="12">
                    <p>Ingrese una parte del documento a buscar</p>
                    <br>
                    <div class=" vx-row flex" style=" flex-wrap: wrap;">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-6">
                            <vs-input vs-w="7" class="w-full" @keyup.enter="getVentaDespachadasxParametro()" icon-after="true" label-placeholder="icon-after" style="margin: 0px 0px 20px 0px" icon="search" placeholder="Buscar" v-model="busquedaxcodigo" />
                        </div>
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-6">
                            <vs-button color="warning" type="filled" style="margin-left: 10px" @click="getVentaDespachadasxParametro()" icon="search"></vs-button>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
            <vs-table v-if="Ventas && Ventas.length > 0" max-items="10" pagination search :data="Ventas">
                <!-- Encabezado -->
                <template v-slot:header>
                    <vs-chip color="primary">Cantidad: <b>{{ Ventas.length }}</b></vs-chip>
                </template>

                <!-- Títulos de las columnas -->
                <template v-slot:thead>
                    <vs-th width="600"># Documento</vs-th>
                    <!-- <vs-th width="100">Empresa remitente</vs-th> -->
                    <vs-th width="900">Información documento</vs-th>
                    <!-- <vs-th width="400">Contratos</vs-th> -->
                    <vs-th width="400">Cantidad de Textos</vs-th>
                    <vs-th width="150">Estado</vs-th>
                    <vs-th width="200">Acciones</vs-th>
                </template>

                <!-- Cuerpo de la tabla -->
                <template v-slot:default="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                        <!-- Documento -->
                        <vs-td :data="tr.ven_codigo">
                            <b class="text-danger">{{tr.idtipodoc==16?'Nota Crédito':tr.idtipodoc==17?'Nota Crédito Interna':''}}</b><br />
                            {{ tr.ven_codigo }} <br>
                            <b v-if="tr.ven_tipo_inst === 'V' || !tr.ven_tipo_inst">Venta Directa</b>
                            <b v-else>Venta Por Lista</b>
                            <br /><b>Facturador: </b>{{ tr.responsable }}
                            <span v-if="tr.ven_tipo_inst === 'V' || !tr.ven_tipo_inst"><br><b>Asesor: </b>{{ tr.asesor }}</span>
                            <span v-if="tr.ven_idproforma"><br /><b>Pre-Proforma: </b>{{ tr.ven_idproforma }}</span>
                            <br />
                            <!-- Empresa remitente -->
                            <b>Empresa: </b><br> <span>{{ tr.nombre }}</span>
                        </vs-td>
                        <!-- Información documento -->
                        <vs-td>
                            <b>Cliente: </b> <br><span v-if="tr.cliente">{{ tr.cliente }}</span>
                            <span v-else> No disponible </span><br />
                            <b>CI/RUC:</b> {{ tr.cedula }}
                            <br />
                            <b>Lugar de Despacho:</b><br> <span>{{ tr.nombreInstitucion }}</span><br />
                            <b>Período escolar: </b><span>{{ tr.periodoescolar }}</span><br />
                            <p class="font-bold">Fecha:</p>
                            <span>{{ tr.ven_fecha }}</span>
                        </vs-td>
                        <!-- Contratos -->
                        <!-- <vs-td>
                            <div v-if="Array.isArray(tr.contratos) && tr.contratos.length > 0">
                                <div :key="k" v-for="(t, k) in tr.contratos">
                                    <p>{{ t.contrato_generado }}</p>
                                </div>
                            </div>
                            <div v-else> No existe contratos</div>
                        </vs-td> -->
                        <!-- Cantidad de Textos e Impresión -->
                        <vs-td>
                            <span>{{ tr.cantidad_despacho }}</span><br />
                            <span v-if="tr.impresion === 0" style="color: aliceblue; background: Teal;">No Impresa</span>
                            <span v-else-if="tr.impresion === 1" style="color: aliceblue; background: DodgerBlue;">Impresa</span>
                            <br />
                            <span v-if="tr.idPuntoventa"><b>Grupo:</b> {{ tr.idPuntoventa }}</span>
                        </vs-td>
                        <!-- Estado -->
                        <vs-td>
                            <!-- <vs-chip v-if="tr.est_ven_codigo === 1" color="#23BF23">Despachado</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 2" color="DarkOrange" type="gradient">Pendiente</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 3" color="LightCoral">Anulada</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 12" color="Gold">Preparada</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 11" color="Orange">Pendiente Excluido</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 10" color="Violet">Empacado</vs-chip>
                            <vs-chip v-else-if="tr.est_ven_codigo === 13" color="Violet">Intercambio</vs-chip>
                            <vs-chip v-if="tr.est_ven_codigo === 14" color="danger">PENDIENTE DE ASOCIAR SRI</vs-chip>
                            <vs-chip v-if="tr.est_ven_codigo === 15" color="LimeGreen">ASOCIADO SRI</vs-chip> -->
                            <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #ff0000" v-if="tr.est_ven_codigo === 3" color="danger">Anulado</div>
                                    <div v-if="tr.usuario_anulado">
                                        <b>Anulado por:</b>
                                        <p>{{ tr.usuario_anulado }}</p>
                                    </div>
                                    <div v-if="tr.fecha_anulacion">
                                        <b>Fecha de anulado:</b>
                                        <p>{{ tr.fecha_anulacion }}</p>
                                    </div>
                                    <div v-if="tr.observacionAnulacion">
                                        <b>Observación anulado:</b>
                                        <p>{{ tr.observacionAnulacion }}</p>
                                    </div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #23BF23" v-if="tr.est_ven_codigo === 1" color="#23BF23">Despachado</div>
                                    <div v-if="tr.est_ven_codigo === 2">
                                        <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: DarkOrange" color="DarkOrange">Pendiente de despacho</div>
                                        <br><br>
                                        <!-- <vs-button v-if="tr.estadoPerseo == 0 && tr.idtipodoc==1 && tr.est_ven_codigo != 3" color="dark" type="border" class="p-3" @click="ObjectSelected=tr;confirmEnviarPerseo(tr)"><i class="fa-brands fa-discord"></i> Enviar a perseo </vs-button> -->
                                    </div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #00BFBF" v-if="tr.est_ven_codigo === 4" color="#00BFBF">Liquidado</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #D86161" v-if="tr.est_ven_codigo === 5" color="#D86161">Deuda</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #009999" v-if="tr.est_ven_codigo === 6" color="#009999">Cargado</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #FF7C26" v-if="tr.est_ven_codigo === 7" color="#FF7C26">Por depositar</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #D800D8" v-if="tr.est_ven_codigo === 8" color="#D800D8">Sin cuenta</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #FF2626" v-if="tr.est_ven_codigo === 9" color="#FF2626">Error cuenta</div>
                                    <div style="padding:5px; border-radius:5px; color:White; font-size:10px;text-align:center; font-weight:bold; background-color: #AF7AC5" v-if="tr.est_ven_codigo === 10" color="#AF7AC5">Empacado</div>
                            <!-- <vs-chip v-if="tr.idtipodoc === 1 && (tr.proformas_codigo === '' || tr.proformas_codigo == null || tr.proformas_codigo == 0)" color="red">No enviado a perseo</vs-chip> -->
                            <br><br>
                            <div v-if="tr.usuario_anulado">
                                <b>Anulado por:</b>
                                <p>{{ tr.usuario_anulado }}</p>
                            </div>
                            <div v-if="tr.fecha_anulacion">
                                <b>Fecha de anulado:</b>
                                <p>{{ tr.fecha_anulacion }}</p>
                            </div>
                            <div v-if="tr.observacionAnulacion">
                                <b>Observación anulado:</b>
                                <p>{{ tr.observacionAnulacion }}</p>
                            </div>
                            <!--INTERCAMBIO-->
                            <div v-if="tr.doc_intercambio" class="mt-5">
                                <b class="text-danger">{{tr.idtipodoc == 1? 'Prefactura movida':'Nota movida'}}:</b>
                                <p>{{ tr.doc_intercambio }}</p>
                                <b>Responsable:</b>
                                <p>{{ tr.user_intercambio }}</p>
                                <b>Fecha de movimiento:</b>
                                <p>{{ tr.fecha_intercambio }}</p>
                                <b v-if="tr.observacion_intercambio">Observación de movimiento:</b>
                                <p v-if="tr.observacion_intercambio">{{ tr.observacion_intercambio }}</p>
                            </div>
                            <!--observacionRegresarAPendiente-->
                            <div v-if="tr.observacionRegresarAPendiente">
                                <p class="font-bold text-danger"><i class="fa-solid fa-circle-exclamation"></i> Observación de despacho:</p>
                                <p>{{ tr.observacionRegresarAPendiente }}</p>
                            </div>
                        </vs-td>
                        <!-- Acciones -->
                        <vs-td :data="tr.ven_codigo">
                            <vs-dropdown vs-custom-content vs-trigger-click title="Opciones">
                                <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                                <vs-dropdown-menu style="width: 250px" class="cursor">
                                    <vs-dropdown-item>
                                        <vs-button color="#28C76F" type="line" class="w-full" @click="factu= tr;getDocumentos(tr.ven_codigo, tr.id_empresa)">Imprimir</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item v-if="userRoot">
                                        <vs-button v-if="tr.est_ven_codigo == 2" color="#1eaed1" type="line" class="w-full" @click="ObjectedSelected= tr;popupDespachar=true;">Despachar</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item v-if="userRoot">
                                        <vs-button v-if="tr.est_ven_codigo == 1 || tr.est_ven_codigo == 10 || tr.est_ven_codigo == 11 || tr.est_ven_codigo == 12" color="Coral" type="line" class="w-full" @click="ObjectedSelected= tr;popupRegresarAPendiente=true;">Regresar a pendiente</vs-button>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup fullscreen :title="`${id}`" v-if="tdo==1&&id" :active.sync="popupImprimir">
                <facturaVue v-if="popupImprimir" :factu="factu" :id="id" @change="change" />
            </vs-popup>
            <vs-popup fullscreen :title="`${id}`" v-if="(tdo==4||tdo==3)&&id&&tip" :active.sync="popupImprime">
                <notaVue v-if="popupImprime" :factu="factu" :id="id" :tipo="tip" @change="change" />
            </vs-popup>
            <vs-popup fullscreen :title="`${id}`" v-if="(tdo==2||tdo==12)&&id" :active.sync="popupActa">
                <actaVue v-if="popupActa" :factu="factu" :id="id" @change="change" />
            </vs-popup>
            <vs-popup fullscreen :active.sync="popupDocumento" v-if="popupDocumento" title="Detalle:">
                <documentoVenta :DocumentoVenta="DocumentoVenta[0]" :DocumentoDetalleVenta="DocumentoDetalleVenta" />
            </vs-popup>
            <!--modal para despachar-->
            <vs-popup class="despachar" :title="`Confirmar Despacho`" :active.sync="popupDespachar">
            <div v-if="popupDespachar">
                <p class="text-2xl text-center">¿Está seguro de despachar la venta <b>{{ ObjectedSelected.ven_codigo }}</b>?</p>
            </div>
            <br>
            <div class="flex justify-center mt-1">
                <vs-button class="mr-5" @click="f_despachar(); popupDespachar=false" type="relief">Aceptar</vs-button>
                <vs-button @click="popupDespachar=false" color="warning" type="relief">Cancelar</vs-button>
            </div>
            </vs-popup>
            <!--modal para mover a pendiente-->
            <vs-popup class="informacionformhijo" :title="`Regresar a Pendiente`" :active.sync="popupRegresarAPendiente">
                <div v-if="popupRegresarAPendiente">
                    <p class="text-center">Regresar a pendiente documento: <b>{{ ObjectedSelected.ven_codigo }}</b></p>
                    <br>
                    <RegresarAPendiente :datadocumento="ObjectedSelected" @change="changePendiente" />
                </div>
            </vs-popup>
        </vx-card>
    </div>
</div>
</template>


<script>
import {
    mapState
} from "vuex";
import Vue from "vue";
import axios from "axios";
import vSelect from "vue-select";
const facturaVue = () => import('@/views/pedidos2/pedidos/proforma/factura.vue');
const notaVue = () => import('@/views/pedidos2/pedidos/proforma/nota.vue');
const actaVue = () => import('@/views/pedidos2/pedidos/libros/librosObsequios/components/actaVuepdf.vue');
const documentoVenta = () => import('@/views/pedidos2/pedidos/proforma/documentoVenta.vue');
const RegresarAPendiente = () => import("@/views/bodega/codigos/components/Regresar_A_Pendiente.vue");

export default {
    components: {
        "v-select": vSelect,
        facturaVue,
        notaVue,
        actaVue,
        documentoVenta,
        RegresarAPendiente,
    },
    data() {
        return {
            Ventas: [],
            DetalleVenta: [],
            userVentas: [],
            popupActivoGuardar: false,
            popupActivoEditar: false,
            popupActivoDesactivar: false,
            popupActivoEliminar: false,
            tabVentas: {
                ven_codigo: "",
                bod_responsable: "",
                bod_nombre: "",
                bod_ubicacion: "",
                bod_estado: "",
                created_at: "",
                opcion: '',
            },
            ven_codigo: 0,
            valorBusqueda: "0",
            Bodega_inactivos: [],
            busquedaxcodigo: "",
            checkBox_mostrarinactivos: false,
            popupImprimir: false,
            popupImprime: false,
            popupActa: false,
            popupAnular: false,
            contadorpendientes: 0,
            menu: 0,
            datos: [],
            id: '',
            tdo: '',
            tip: '',
            factu: [],
            DocumentoDetalleVenta: [],
            DocumentoVenta: [],
            popupDocumento: false,
            ObjectedSelected:'',
            popupDespachar:false,
            popupRegresarAPendiente:false,
            usuario:[],
        };
    },

    mounted() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
        this.Ventas = [];
    },
    props: {
        periodoSelect: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'userAsesor', 'groupFacturador']),
    },
    methods: {
        f_despachar() {
            let me = this;
            let datos = {
                ven_codigo: this.ObjectedSelected.ven_codigo,
                est_ven_codigo: 1,
                id_empresa: this.ObjectedSelected.id_empresa,
                user_despacha:this.usuario.idusuario
            };
            me.$vs.loading();
            this.$http
                .post(this.$server_url + "Desactivar_venta", datos)
                .then((res) => {
                    me.$vs.loading.close();
                     if(res.data.status == 0){
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle',
                            time:3000
                        })
                        this.getVentaDespachadasxParametro();
                        return
                    }
                    this.getVentaDespachadasxParametro();
                    me.$vs.notify({
                        text: "Despacho exitoso",
                        color: "success",
                        iconPack: "feather",
                        icon: "icon-check",
                    });
                    this.popupDespachar = false;
                })
                .catch((error) => {
                    console.log(error);
                    me.$vs.loading.close();
                    me.$vs.notify({
                        text: "No se pudo despachar",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                    });
                });

        },
        changePendiente(e){
            let me = this
            if (e.verificacionemitsaveandedit == 1) {
                me.popupRegresarAPendiente = false;
                this.getVentaDespachadasxParametro();
            } else if (e.verificacionemitsaveandedit == 2) {
                me.popupRegresarAPendiente = false;
            } else {
            }
        },
        getDocumentos(documentos, empresa) {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'devoluciones?CargarDocumentos=yes&documentos=' + documentos + '&empresa=' + empresa)
                .then((res) => {
                    me.DocumentoVenta = res.data;
                    if (me.DocumentoVenta.length > 0) {
                        let codigo = me.DocumentoVenta[0].ven_codigo;
                        let empresa = me.DocumentoVenta[0].empresa_id;
                        this.getDocumentosDetalles(codigo, empresa);
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Documento no encontrado.',
                            type: 'error',
                        });
                    }

                    me.$vs.loading.close();
                })
                .catch((err) => {
                    console.error(err);
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Hubo un problema al cargar los documentos.',
                        type: 'error',
                    });
                    me.$vs.loading.close();
                });
        },
        getDocumentosDetalles(codigo, empresa) {
            let me = this;
            // console.log(codigo, empresa,'dsdsadsaddsa');
            me.$vs.loading();
            this.$http.get(this.$server_url + 'devoluciones?CargarDocumentosDetalles=yes&codigo=' + codigo + '&empresa=' + empresa)
                .then((res) => {
                    this.DocumentoDetalleVenta = res.data;
                    if (this.DocumentoDetalleVenta.length > 0) {
                        this.popupDocumento = true;
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Detalle Documento no encontrado.',
                            type: 'error',
                        });
                    }
                    me.$vs.loading.close();
                })
                .catch((err) => {
                    console.error(err);
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Hubo un problema al cargar los detalles de los documentos.',
                        type: 'error',
                    });
                    me.$vs.loading.close();
                });
        },
        change(e) {
            if (e == true) {
                this.tdo = 0;
            }
        },
        changen(e) {
            if (e == true) {

            }
        },
        getreporte(tr) {
            this.tdo = 0;
            this.id = tr.ven_codigo;
            if (tr.idtipodoc == 1) {
                this.tdo = 1;
                this.popupImprimir = true;
            }
            if (tr.idtipodoc == 2) {
                this.tdo = 4;
                this.popupActa = true;
            }
            if (tr.idtipodoc == 3) {
                this.tip = 1;
                this.tdo = 2;
                this.popupImprime = true;
            }
            if (tr.idtipodoc == 4) {
                this.tip = 1;
                this.tdo = 3;
                this.popupImprime = true;
            }
        },
        getVentaDespachadasxParametro() {
            let me = this;
            me.Ventas = [];
            if (me.busquedaxcodigo.length < 4) {
                me.$vs.notify({
                    text: "Minimo 4 caracteres de busqueda",
                    color: "warning",
                    iconPack: "feather",
                    icon: "icon-check",
                });
                return false;
            }
            let id = me.periodoSelect.idperiodoescolar;
            me.$vs.loading();
            this.$http.get(this.$server_url + "GetVentasDespachadasxParametro?opcion=1&parte_documento=" + me.busquedaxcodigo + '&periodo=' + id)
                .then(function (res) {
                    me.Ventas = res.data;
                    if (me.Ventas.length === 0) {
                        me.$vs.notify({
                            text: "No hay Ventas para esta búsqueda",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                        me.Ventas = [];
                        me.$vs.loading.close();
                    } else {
                        // me.filtroRegion();
                        me.$vs.loading.close();
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: "success",
                                iconPack: "feather",
                                icon: "icon-user",
                            });
                        }
                    }
                })
                .catch(function (error) {
                    if (error.response && error.response.status === 404) {
                        me.$vs.notify({
                            text: "No hay Ventas para esta búsqueda",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                        me.Ventas = [];
                        me.$vs.loading.close();
                    } else {
                        console.log(error + " error");
                        me.Ventas = [];
                        me.$vs.loading.close();
                    }
                });
        },
        getCancelar() {
            this.popupActivoEditar = false;
            this.popupActivoGuardar = false;
            this.popupActivoEliminar = false;
            this.popupActivoDesactivar = false;
        },

    },
};
</script>


<style>
.text {
    z-index: 9;
    background: var(--bg);
    color: var(--color);
    font-size: 11px;
    padding: 1.5px;
    border-radius: 1px;
    height: fit-content;
    cursor: pointer;
    box-shadow: 0 4px 16px 4px rgba(0, 0, 0, 0.15);
}
</style>
